export const APP_LOCALE = "en-US";

export const INTERVIEW_MINIMUM_START_MINUTES = 10;
